import React from 'react';
import styles from '../../css/About/TeamSection.module.css';
import image from '../../assets/images/tra.png';
import { Link } from 'react-router-dom';

const teamMembers = [
	{
		name: 'Jane Cooper',
		role: 'Marketing Coordinator',
		image: image,
		socials: [
			// { icon: '/icons/fb.svg', alt: 'Facebook', link: '#' },
			// { icon: '/icons/insta.svg', alt: 'Instagram', link: '#' },
			// { icon: '/icons/wa.svg', alt: 'WhatsApp', link: '#' },
		],
	},
	{
		name: 'Darlene Robertson',
		role: 'Marketing Coordinator',
		image: image,
		socials: [],
	},
	{
		name: 'Darrell Steward',
		role: 'Marketing Coordinator',
		image: image,
		socials: [],
	},
	{
		name: 'Jenny Wilson',
		role: 'Marketing Coordinator',
		image: image,
		socials: [],
	},
];

function TeamSection() {
	return (
		<section className={styles.teamSection}>
			<div className={styles.btnSection}>
				<div className={styles.headerGroup}>
					<h1 className={styles.mainTitle}>Crafting Excellence as a Team</h1>
					<p className={styles.subtitle}>
						Our success is built on the dedication and expertise of our team,
						who work together to bring innovative ideas and exceptional
						craftsmanship to every project. Together, we turn visions into
						reality.
					</p>
				</div>
				<Link className={styles.exploreBtn}>Get Started</Link>
			</div>

			
			<div className={styles.cardsRow}>
				{teamMembers.map((member, idx) => (
					<div className={styles.teamCard} key={member.name}>
						<div className={styles.imgBlock}>
							<img
								src={member.image}
								alt={member.name}
								className={styles.profileImg}
							/>
							{member.socials.length > 0 && (
								<div className={styles.socials}>
									{member.socials.map((soc, i) => (
										<a href={soc.link} key={i}>
											<img
												src={soc.icon}
												alt={soc.alt}
												className={styles.socialIcon}
											/>
										</a>
									))}
								</div>
							)}
						</div>
						<div className={styles.memberInfo}>
							<div className={styles.memberName}>{member.name}</div>
							<div className={styles.memberRole}>{member.role}</div>
						</div>
					</div>
				))}
			</div>
		</section>
	);
}

export default TeamSection;
